<template>
  <cv-content-switcher-button ref="root" :tabindex="tabIndex">
    <slot />
  </cv-content-switcher-button>
</template>

<script setup lang="ts">
import { computed, useAttrs, useTemplateRef, watch } from "vue";

const root = useTemplateRef<HTMLElement | null>("root");

const attrs = useAttrs();

const tabIndex = computed(() => (attrs.selected ? 0 : -1));

watch(
  () => attrs.selected,
  () => {
    if (attrs.selected && !attrs.disabled) {
      root.value?.$el.click();
    }
  },
);
</script>
